import request from '@/utils/request'

export function getHomeData() {
    return request({
        url: '/homemanager/data',
        method: 'post'
    })
}

export default{
    getHomeData
}